import * as React from 'react';

const HeaderLayoutRight = (props) => {
  return (
    <div className="m__head__right">
      {props.children}
    </div>
  )
};

export default HeaderLayoutRight;
